import ua from 'universal-analytics';

export default ua(process.env.REACT_APP_TRACKING_ID || 'UA-80271114-15');
